import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaFilter, FaPlus } from "react-icons/fa";
import { getAllActiveProvider, getOrganisation } from "../../../config/LiveApi";
import "./ProviderTable.css";
import AddPayinModal from "./AddPayinModal";
import AddPayoutModal from "./AddPayoutModal";
import ProviderModal from "../SuccessModal/ProviderModal";
import UserModal from "../SuccessModal/UserModal";
import ProviderBalanceModal from "../SuccessModal/ProviderBalanceModal";
import UserPayoutSuccessModal from "../SuccessModal/UserPayoutSuccessModal";

const Table = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [provider, setProvider] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [modalType, setModalType] = useState(null);

  // Filters
  const [orgName, setOrgName] = useState(false);
  const [selectedOrgName, setSelectedOrgName] = useState("All");
  const [orgOptions, setOrgOptions] = useState([]);
  const [showType, setShowType] = useState(false);
  const [typeFilter, setTypeFilter] = useState("");

  // 🔎 Search state with debounce
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [providerModal, setProviderModal] = useState(false);
  const [userModal, setUserModal] = useState(false);
  const [providerBlanceModal, setProviderBlanceModal] = useState(false);
  const [userPayoutSuccessModal, setUserPayoutSuccessModal] = useState(false);

  const orgRef = useRef(null);
  const typeRef = useRef(null);

  useEffect(() => {
    fetchAllProvider();
  }, []);

  const fetchAllProvider = async () => {
    setIsLoading(true);
    try {
      const response = await getAllActiveProvider(token);
      setProvider(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch providers.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddClick = (providerId, type) => {
    setSelectedProvider(providerId);
    setModalType(type);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
        toast.error("Unable to fetch organisations.");
      }
    };

    fetchOrganisations();
  }, [token]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (orgRef.current && !orgRef.current.contains(e.target)) {
        setOrgName(false);
      }
      if (typeRef.current && !typeRef.current.contains(e.target)) {
        setShowType(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const renderMerchantList = (merchants, showAddIcon, providerId, type) => {
    return (
      <div className="merchant-list">
        {(!merchants || merchants.length === 0) && (
          <span className="merchant-empty">-</span>
        )}

        {merchants &&
          merchants.map((u) => (
            <span key={u.id} className="merchant-badge">
              {u?.alias || u?.id || ""}
            </span>
          ))}

        {showAddIcon && (
          <button
            className="merchant-add-btn"
            onClick={() => handleAddClick(providerId, type.toLowerCase())}
          >
            <FaPlus />
          </button>
        )}
      </div>
    );
  };

  // ✅ Apply filters (Org + Type + Search)
  const filteredProviders = provider.filter((prov) => {
    let orgMatch = true;
    let typeMatch = true;
    let searchMatch = true;

    if (selectedOrgName && selectedOrgName !== "All") {
      orgMatch = prov.orgName === selectedOrgName;
    }

    if (typeFilter) {
      if (typeFilter === "both") {
        typeMatch = prov.type === "both";
      } else {
        typeMatch = prov.type === typeFilter;
      }
    }

    if (debouncedSearchTerm) {
      searchMatch = prov.providerName
        .toLowerCase()
        .includes(debouncedSearchTerm.toLowerCase());
    }

    return orgMatch && typeMatch && searchMatch;
  });

  return (
    <div className="provider-report-table-container">
      <div className="provider-report-table-header">
        <div>
        <h2 className="provider-report-table-title">All Active Providers</h2>
         <button className="provider-success-rate-buttton"
         onClick={() => setProviderModal(true)}>Provider Success Rate</button>
          <button className="provider-success-rate-buttton-1"
            onClick={() => setUserModal(true)}>User Success Rate</button>
            <button className="provider-success-rate-buttton-1"
            onClick={() => setUserPayoutSuccessModal(true)}>User Payout Success Rate</button>
           <button className='provider-success-rate-buttton-2'
            onClick={() => setProviderBlanceModal(true)}>Provider Balance</button>
         </div>

        <input
          className="provider-key-input-field-container"
          type="text"
          placeholder="Enter Provider Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <table className="provider-table">
        <thead>
          <tr>
            <th>Provider Name</th>
            <th className="filter-pos" ref={orgRef}>
              <div className="data-icon">
                <p className="user-table-head-report">Org Name</p>
                <FaFilter
                  style={{
                    marginRight: "0.2rem",
                    width: "1rem",
                    height: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => setOrgName((prev) => !prev)}
                />
              </div>
              {orgName && (
                <div className="filter-dropdown">
                  <div
                    className={`filter-option ${
                      selectedOrgName === "All" ? "active" : ""
                    }`}
                    onClick={() => {
                      setSelectedOrgName("All");
                      setOrgName(false);
                    }}
                  >
                    All
                  </div>
                  <div
                    style={{
                      maxHeight: "250px",
                      overflowY: "auto",
                      padding: "0.5rem",
                    }}
                  >
                    {orgOptions.map((org) => (
                      <div
                        key={org.id}
                        className={`filter-option ${
                          selectedOrgName === org.orgName ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedOrgName(org.orgName);
                          setOrgName(false);
                        }}
                      >
                        {org.orgName}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </th>

            {/* Type Filter */}
            <th className="filter-pos" ref={typeRef}>
              <div className="data-icon">
                <p className="user-table-head-report">Type</p>
                <FaFilter
                  style={{
                    marginRight: "0.2rem",
                    width: "1rem",
                    height: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowType((prev) => !prev)}
                />
              </div>
              {showType && (
                <div className="filter-dropdown">
                  <div
                    className={`filter-option ${
                      typeFilter === "" ? "active" : ""
                    }`}
                    onClick={() => {
                      setTypeFilter("");
                      setShowType(false);
                    }}
                  >
                    All
                  </div>
                  <div
                    className={`filter-option ${
                      typeFilter === "payin" ? "active" : ""
                    }`}
                    onClick={() => {
                      setTypeFilter("payin");
                      setShowType(false);
                    }}
                  >
                    Payin
                  </div>
                  <div
                    className={`filter-option ${
                      typeFilter === "payout" ? "active" : ""
                    }`}
                    onClick={() => {
                      setTypeFilter("payout");
                      setShowType(false);
                    }}
                  >
                    Payout
                  </div>
                  <div
                    className={`filter-option ${
                      typeFilter === "both" ? "active" : ""
                    }`}
                    onClick={() => {
                      setTypeFilter("both");
                      setShowType(false);
                    }}
                  >
                    Both
                  </div>
                </div>
              )}
            </th>
            <th>Payin (Limit / Used)</th>
            <th>Payout (Limit / Used)</th>
            <th>Payin Merchant</th>
            <th>Payout Merchant</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : filteredProviders.length > 0 ? (
            filteredProviders.map((prov) => {
              const showPayinAdd =
                prov.type === "payin" || prov.type === "both";
              const showPayoutAdd =
                prov.type === "payout" || prov.type === "both";

              return (
                <tr key={prov.id}>
                  <td>{prov.providerName}</td>
                  <td>{prov.orgName}</td>
                  <td>{prov.type}</td>
                  <td>
                    {prov.type === "payin" || prov.type === "both" ? (
                      <>
                        {(() => {
                          const used = prov.providerLimitUsed?.payin || 0;
                          const limit = prov.providerLimit?.payin || 0;
                          const usagePercent =
                            limit > 0 ? (used / limit) * 100 : 0;

                          return (
                            <span
                              className={
                                usagePercent >= 90
                                  ? "used-limit-red"
                                  : "used-limit-green"
                              }
                            >
                              {used.toLocaleString()}
                            </span>
                          );
                        })()}
                        {" / "}
                        {prov.providerLimit?.payin?.toLocaleString() || 0}
                      </>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td>
                    {prov.type === "payout" || prov.type === "both" ? (
                      <>
                        {(() => {
                          const used = prov.providerLimitUsed?.payout || 0;
                          const limit = prov.providerLimit?.payout || 0;
                          const usagePercent =
                            limit > 0 ? (used / limit) * 100 : 0;

                          return (
                            <span
                              className={
                                usagePercent >= 90
                                  ? "used-limit-red"
                                  : "used-limit-green"
                              }
                            >
                              {used.toLocaleString()}
                            </span>
                          );
                        })()}
                        {" / "}
                        {prov.providerLimit?.payout?.toLocaleString() || 0}
                      </>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td>
                    {renderMerchantList(
                      prov.payin,
                      showPayinAdd,
                      prov.id,
                      "Payin"
                    )}
                  </td>
                  <td>
                    {renderMerchantList(
                      prov.payout,
                      showPayoutAdd,
                      prov.id,
                      "Payout"
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6">No Active Provider found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {showModal && modalType === "payin" && (
        <AddPayinModal
          providerId={selectedProvider}
          onClose={() => setShowModal(false)}
          onSuccess={fetchAllProvider}
        />
      )}

      {showModal && modalType === "payout" && (
        <AddPayoutModal
          providerId={selectedProvider}
          onClose={() => setShowModal(false)}
          onSuccess={fetchAllProvider}
        />
      )}
      {providerModal && (
  <ProviderModal setShowModal={setProviderModal} />
)}
{userModal && (
  <UserModal setShowModal={setUserModal} />
)}
{providerBlanceModal && (
  <ProviderBalanceModal setShowModal={setProviderBlanceModal} />
)}
{userPayoutSuccessModal && (
  <UserPayoutSuccessModal setShowModal={setUserPayoutSuccessModal} />
)}

    </div>
  );
};

export default Table;
